export const LANGUAGE = {
    EN: 'en',
    MX: 'mx',
};
export const DEFAULT_LANGUAGE = LANGUAGE.EN;
export const LANGUAGE_TEXT_MAP = {
    [LANGUAGE.EN]: 'English',
    [LANGUAGE.MX]: 'Español',
};
export const USLanguageOptions = [
    { text: LANGUAGE_TEXT_MAP[LANGUAGE.EN], value: LANGUAGE.EN },
    { text: LANGUAGE_TEXT_MAP[LANGUAGE.MX], value: LANGUAGE.MX },
];
/* Internationalization Locale Code */
export const INTL_LOCALE = {
    EN: 'en',
    MX: 'es-MX',
};
export const INTL_LOCALE_MAP = {
    [LANGUAGE.EN]: INTL_LOCALE.EN,
    [LANGUAGE.MX]: INTL_LOCALE.MX,
};
export const GOOGLE_MAP_LANGUAGE_MAP = {
    [INTL_LOCALE.EN]: 'en',
    [INTL_LOCALE.MX]: 'es',
};
